import { Box, Center, Text } from '@chakra-ui/react'
import {
  BaseQuery,
  CollectionSort,
  Fax,
  FAX_RECEIVED_COLLECTION,
  FAX_SENT_COLLECTION,
  formatPhoneNumber,
  FROM_NUMBER,
} from '@hb/shared'

import { useContext } from 'react'
import { DataListTab } from '../../types/data'
import { DataList } from '../DataList'
import { PatientProfile } from '../Users/Profile/PatientProfile'
import { PageContainer } from '../Views/PageContainer'

import { ScreenContext } from '@hb/react'
import { useParams } from 'react-router-dom'
import { SearchBarProvider } from '../../contexts/SearchBarContext'
import { AssignFaxToAssessmentModal } from './AssignFaxToAssessmentModal'
import { receivedFaxColumns, sentFaxColumns } from './columns'
import { FaxesViewContext } from './context'
import { FaxesViewProvider } from './FaxesViewProvider'

const faxSentBaseQuery: BaseQuery<Fax> = {
  collection: FAX_SENT_COLLECTION,
}

const faxReceivedBaseQuery: BaseQuery<Fax> = {
  collection: FAX_RECEIVED_COLLECTION,
}

const createdAtSort: CollectionSort<Fax> = {
  field: 'created_at',
  order: 'desc',
}
export const sentFaxTab: DataListTab<Fax> = {
  baseQuery: faxSentBaseQuery,
  columns: sentFaxColumns,
  searchStringPath: 'searchString',
  defaultSort: createdAtSort,
  itemName: 'sent fax',
}

export const receivedFaxTab: DataListTab<Fax> = {
  baseQuery: faxReceivedBaseQuery,
  columns: receivedFaxColumns,
  searchStringPath: 'searchString',
  defaultSort: createdAtSort,
  itemName: 'received fax',
}

export const faxesTabs: Record<string, DataListTab<Fax>> = {
  'Sent Faxes': sentFaxTab,
  'Received Faxes': receivedFaxTab,
}

// remove spaces from search query
const transformSearchQuery = (query: string) => query.replace(/\s/g, '')
const FaxesViewBody = () => {
  const { tabIndex, onChangeTab } = useContext(FaxesViewContext)
  const { contentHeight } = useContext(ScreenContext)
  return (
    <PageContainer noFooter>
      <Box position="relative">
        <SearchBarProvider transformQuery={transformSearchQuery}>
          <DataList
            tabIndex={tabIndex}
            height={contentHeight - 50}
            onTabChange={onChangeTab}
            rootPath="fax"
            tabs={faxesTabs}
          />
        </SearchBarProvider>
        <Center zIndex={2} position="absolute" top={0} right={0} py={2} px={3}>
          <Text fontFamily="Open Sans" color="gray.600">
            HB Fax #: {formatPhoneNumber(FROM_NUMBER)}
          </Text>
        </Center>
      </Box>
    </PageContainer>
  )
}

const FaxesViewAssessmentModal = () => {
  const { faxType = 'sent' } = useParams()
  return <PatientProfile basePath={`/admin/fax/${faxType}`} />
}

export const FaxesView = () => (
  <FaxesViewProvider>
    <FaxesViewBody />
    <FaxesViewAssessmentModal />
    <AssignFaxToAssessmentModal />
  </FaxesViewProvider>
)
